import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function About() {
  return (
    <div id="top">
      <SEO 
        title="About Kimberly Palermo"
        description="Kimberly Palermo is an educator, writer, and cultural analyst helping people understand America's hidden history and systemic racism through accessible, research-based education."
        keywords="Kimberly Palermo, Kim Synergy, educator, anti-racism educator, systemic racism expert, social justice advocate, cultural analyst, diversity training"
        url="https://indoctrination365.com/about"
        image="/profile.jpeg"
      />
    <main className="py-16">
      <div id="top" />
      <div className="max-w-4xl mx-auto px-6">

        {/* Top: photo + name intro */}
        <div className="flex flex-col sm:flex-row gap-8 items-center sm:items-start mb-12">
          <div className="shrink-0 w-48 h-48 rounded-full overflow-hidden" style={{boxShadow: '0 8px 20px rgba(0,0,0,0.15)'}}>
            <img
              src="/profile.jpeg"
              alt="Kimberly Palermo"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="text-center sm:text-left">
            <h1 className="text-4xl font-bold mb-2">Kimberly Palermo</h1>
            <p className="text-xl text-primary-600 font-medium mb-3">Educator · Writer · Cultural Analyst</p>
            <p className="text-gray-600 leading-relaxed max-w-xl">
              Helping the most reluctant and misinformed learners understand America's hidden history
              and the systems that continue to shape our lives today.
            </p>
          </div>
        </div>

        {/* Bio */}
        <div className="space-y-5 text-lg text-gray-700 leading-relaxed mb-12">
          <p>
            Kimberly holds an undergraduate degree in Applied Behavioral Sciences from UC Davis,
            with a focus on multiculturalism, and a master's degree in Special Education, with
            extensive training in group behavior and learning.
          </p>
          <p>
            Kim began her teaching career as an elementary school teacher in Compton Unified School
            District during the Rodney King civil unrest, where she witnessed firsthand how historical
            erasure, systemic inequality, and trauma shape communities — and how education can either
            reinforce myths or interrupt them. That experience profoundly shaped her approach to
            teaching truth with clarity, empathy, and accountability.
          </p>
          <p>
            For over twenty years, Kim has worked with people at the earliest stages of learning, including those who have received incomplete or oversimplified versions of history, helping guide them from uncertainty toward deeper understanding and personal responsibility.
          </p>
          <p className="italic border-l-4 border-primary-400 pl-4">
            Indoctri-NATION 365 reflects Kim's lifelong work at the intersection of education,
            behavioral science, and history — designed not to shame readers, but to give them the
            tools they were never taught.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            To better understand American culture today, this book offers the clarity you've been looking for.
          </p>
        </div>

        {/* Mission */}
        <div className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">My Mission</h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            I wrote this book because I believe deeply in the power of truth, education, and transformation.
            For generations, many of us have been taught an incomplete version of our nation's history.
            Those gaps were not accidental, and they continue to shape how we see ourselves, each other,
            and the world around us. This work exists to bring clarity where there has been silence and
            understanding where there has been confusion.
          </p>
        </div>

        {/* Why This Work Matters */}
        <div className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">Why This Work Matters</h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            Real change begins with honest understanding. Without it, progress stalls and harm continues.
            This book is designed to meet people exactly where they are, offering compassion, patience,
            and clarity without compromising the truth. It provides the historical context and practical
            tools needed to move from awareness into meaningful, responsible action that can shape a
            more just future.
          </p>
        </div>

        {/* Connect */}
        <div className="bg-primary-50 rounded-lg p-8">
          <h2 className="text-2xl font-semibold mb-3">Connect With Kim</h2>
          <p className="text-lg text-gray-700 mb-6">
            Whether you're just beginning your journey or looking to deepen your understanding,
            Kim is here to support your learning.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="https://linkedin.com/in/synergyunlimited"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
            >
              LinkedIn
            </a>
            <Link
              to="/contact"
              className="border-2 border-primary-600 text-primary-600 px-6 py-3 rounded-lg font-semibold hover:bg-primary-50 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
            >
              Send a Message
            </Link>
          </div>
        </div>

      </div>
    </main>
    </div>
  )
}
